import { colors, unit } from '@acast/decibel';
import T from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const ProgressBarContainer = styled.div`
  height: ${unit(1)};
  overflow: hidden;
  position: relative;
  border-radius: 2px;
  width: 100%;
  background-color: ${colors.blue16};
`;

const ProgressBarLine = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  bottom: 0;
  position: absolute;
  transition: transform 200ms linear;
  transform-origin: left;
  background-color: ${colors.blue};
  border-radius: inherit;
  transform: translateX(${props => `-${props.x}%`});
`;

export default function ProgressBar({ value = 0, valueText, max = 100, min = 0 }) {
  const x = max - value;
  return (
    <ProgressBarContainer
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={min}
      aria-valuemax={max}
      aria-valuetext={valueText}
    >
      <ProgressBarLine x={x} />
    </ProgressBarContainer>
  );
}

ProgressBar.propTypes = {
  value: T.number,
  min: T.number,
  max: T.number,
  valueText: T.string,
};
